// src/store/index.js
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import configReducer from "./configSlice";
import mapReducer from "./mapSlice";
import dataReducer from "./dataSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    config: configReducer,
    map: mapReducer,
    data: dataReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "auth/setUser",
          "auth/signIn/fulfilled",
          "auth/restoreSession/fulfilled",
          "config/fetchClientConfig/fulfilled",
          "data/fetchGeoJSON/fulfilled",
          "data/fetchScoredData/fulfilled",
          "data/fetchMapData/fulfilled",
        ],
        ignoredPaths: [
          "auth.user",
          "config.clientConfig",
          "data.geoJSON",
          "data.scoredData",
        ],
      },
    }),
});

export default store;
